import fileCloseSvg from './file-close-svg';
import folderSvg from './folder-svg';
import {trimFileName} from "../../services/helpers";
import { MODE } from '../../constants/file-image-types';

export default function drawFolder (checkedFiles, data, mode = MODE.EDIT) {
  let html = '';
  
  const checkedFileIds = checkedFiles.map(file => file.id);

  data.forEach(element => {
    html += `<div
      class="grid-item ${checkedFileIds.includes(element.id) ? 'selected' : ''}"
      data-grid-item-id="${element.id}"
      data-grid-item-type="folder"
      data-grid-item-name="${element.name}"
      data-toggle="tooltip"
      data-placement="bottom"
      title="${element.name}"
    >`
    html += "<input type='hidden' class='hidden-input' value='" + element.id + "'/>";
    html += "<input type='hidden' class='hidden-type-input' value='" + element.type + "'/>";
    html += "<input type='hidden' class='hidden-name-input' value='" + element.name + "'/>";
    html += "<input type='hidden' class='hidden-parent-id-input' value='" + element.parent_id + "'/>";
    html += "<input type='hidden' class='hidden-company-id-input' value='" + element.company_id + "'/>";
    html += "<input type='checkbox' class='select-check' />";

    if (element.status === 'new') {
      html += "<span class='budge'>New</span>";
    }


    html += `<div class="file-folder">`;
    if (mode == MODE.EDIT) {
      html += `<div class="file-edit" data-toggle="tooltip" data-placement="top" title="Edit"><i class="fa fa-edit" id="file-edit"></i></div>`;
      html += fileCloseSvg();
    }
    html += folderSvg({
      color: element.color || null,
      emoji: element.emoji || null,
    });
    html += `</div>`;
    html += "<p class='grid-image-title'>" + trimFileName(element.name, 10) + "</p>";
    html += "<input type='text' class='name-input' placeholder='New file name' value='" + element.name + "' data-grid-item-id='"+ element.id + "'/>";
    html += "<p class='grid-image-size'></p>";
    html += "<p class='grid-image-created'>" + (element.created_at) + "</p>";
    html += "<p class='grid-image-type'></p>";
    html += "<div class='table-action-buttons'>";
    if (mode == MODE.EDIT) {
      html += "<div class=\"file-edit\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Edit\"><i class=\"fa fa-edit\" id=\"file-edit\"></i></div>";
      html += "<div class=\"file-delete\" data-toggle=\"tooltip\" data-placement=\"top\" title=\"Delete\"><i class=\"fa fa-trash\" id=\"file-delete\"></i></div>";
    }
    html += "</div>";
    html += "</div>";
  });

  return $(html)
}
